import React from 'react';
import Button from 'react/views/generic/Button';
import CardFooter from './CardFooter';

function SingleButtonFooter(props) {
    let {buttonText, ...restOfProps } = props;

    return (
        <CardFooter rightContent={<Button {...restOfProps} small>{buttonText}</Button>} />
    );
}

export default SingleButtonFooter;



// WEBPACK FOOTER //
// ./src/react/card/SingleButtonFooter.jsx